import { createI18n } from 'vue-i18n';
import {ru_messages} from './locales/ru.js'
const messages = {
  ru: ru_messages,
};

export default createI18n({
  locale: 'ru',
  fallbackLocale: 'ru',
  messages,
});
